export default __webpack_public_path__ + "static/media/lab-background.eef88a51.svg";